import { defineMessages } from 'react-intl-next';

const msgForWorked = defineMessages({
	youIndividualWorkedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.today',
		defaultMessage: 'You worked on this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when you performed an unknown operation on the work today',
	},
	youIndividualWorkedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.yesterday',
		defaultMessage: 'You worked on this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when you performed an unknown operation on the work yesterday',
	},
	youIndividualWorkedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.time',
		defaultMessage: 'You worked on this {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when you performed an unknown operation on the work earlier than yesterday',
	},
});

const msgForCommented = defineMessages({
	youIndividualCommentedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.today',
		defaultMessage: 'You commented here today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user commented on the work today',
	},
	youIndividualCommentedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.yesterday',
		defaultMessage: 'You commented here yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user commented on the work yesterday',
	},
	youIndividualCommentedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.time',
		defaultMessage: 'You commented here on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user commented on the work earlier than yesterday',
	},
});

const msgForCreated = defineMessages({
	youIndividualCreatedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.created.today',
		defaultMessage: 'You created this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user created the work today',
	},
	youIndividualCreatedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.created.yesterday',
		defaultMessage: 'You created this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user created the work yesterday',
	},
	youIndividualCreatedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.created.time',
		defaultMessage: 'You created this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user created the work earlier than yesterday',
	},
});

const msgForEdited = defineMessages({
	youIndividualEditedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.today',
		defaultMessage: 'You edited this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user edited the work today',
	},
	youIndividualEditedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.yesterday',
		defaultMessage: 'You edited this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user edited the work yesterday',
	},
	youIndividualEditedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.time',
		defaultMessage: 'You edited this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user edited the work earlier than yesterday',
	},
});

const msgForAssigned = defineMessages({
	youIndividualAssignedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.today',
		defaultMessage: 'You were assigned this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user is assigned the work today',
	},
	youIndividualAssignedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.yesterday',
		defaultMessage: 'You were assigned this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user is assigned the work yesterday',
	},
	youIndividualAssignedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.time',
		defaultMessage: 'You were assigned this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user is assigned the work earlier than yesterday',
	},
});

const msgForUnassigned = defineMessages({
	youIndividualUnassignedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.today',
		defaultMessage: 'You were unassigned this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user is unassigned the work today',
	},
	youIndividualUnassignedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.yesterday',
		defaultMessage: 'You were unassigned this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user is assigned the work yesterday',
	},
	youIndividualUnassignedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.time',
		defaultMessage: 'You were unassigned this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user is unassigned the work earlier than yesterday',
	},
});

const msgForLiked = defineMessages({
	youIndividualLikedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.today',
		defaultMessage: 'You liked this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user liked the work today',
	},
	youIndividualLikedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.yesterday',
		defaultMessage: 'You liked this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user is assigned the work yesterday',
	},
	youIndividualLikedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.time',
		defaultMessage: 'You liked this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user liked the work earlier than yesterday',
	},
});

const msgForPublished = defineMessages({
	youIndividualPublishedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.published.today',
		defaultMessage: 'You published this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user published the work today',
	},
	youIndividualPublishedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.published.yesterday',
		defaultMessage: 'You published this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user is assigned the work yesterday',
	},
	youIndividualPublishedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.published.time',
		defaultMessage: 'You published this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user published the work earlier than yesterday',
	},
});

const msgForUpdated = defineMessages({
	youIndividualUpdatedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.today',
		defaultMessage: 'You updated this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user updated the work today',
	},
	youIndividualUpdatedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.yesterday',
		defaultMessage: 'You updated this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user is assigned the work yesterday',
	},
	youIndividualUpdatedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.time',
		defaultMessage: 'You updated this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when the current user updated the work earlier than yesterday',
	},
});

// Messages for when you performed an action
export const messages = {
	...msgForWorked,
	...msgForCommented,
	...msgForCreated,
	...msgForEdited,
	...msgForAssigned,
	...msgForUnassigned,
	...msgForLiked,
	...msgForPublished,
	...msgForUpdated,
};
